/**
 * Число из API/БД: null/undefined/пустая строка → null (не путать с 0).
 * Строки вроде "947" и числа проходят как finite.
 */
export function parseOptionalFiniteNumber(value: unknown): number | null {
  if (value === null || value === undefined) return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
